import { render, staticRenderFns } from "./InscripcionesPage.vue?vue&type=template&id=84623eee&scoped=true"
import script from "./InscripcionesPage.js?vue&type=script&lang=js&external"
export * from "./InscripcionesPage.js?vue&type=script&lang=js&external"
import style0 from "./InscripcionesPage.vue?vue&type=style&index=0&id=84623eee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84623eee",
  null
  
)

export default component.exports